/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Include_Vchip_InfoInputs */



/**
* | output |
* | --- |
* | "Include V-Chip Information" |
*
* @param {Subtitle_Export_Include_Vchip_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_include_vchip_info = /** @type {((inputs?: Subtitle_Export_Include_Vchip_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Include_Vchip_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure les informations sur la puce V")
	if (locale === "de") return /** @type {LocalizedString} */ ("V-Chip-Informationen einbeziehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi informazioni sul V-Chip")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включите информацию о V-чипе.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir información del V-Chip")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("包含 V-Chip 信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Vチップ情報を含める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वी-चिप की जानकारी शामिल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluir informações do V-Chip")
	return /** @type {LocalizedString} */ ("Include V-Chip Information")
});